// 运营后台模型对比页（C27）文案：en、zh、ja、es、pt 五份，id 由 en 派生。输入方式与段落方式复用对局审计页的枚举文案。
export const novelComparisonEn = {
  open: 'Model comparison',
  title: 'Model comparison',
  fromTurn: 'From turn {count}',
  playerUnknown: 'Unknown player',
  sourceMissing: 'Source run deleted',
  back: 'Back to run',
  expires: 'Cleaned up automatically at {time}',
  history: 'Story so far',
  narrator: 'Narrator',
  inputMode: 'Input mode',
  input: 'Player input',
  inputHint: 'Up to {max} characters, same as a play turn',
  send: 'Generate both',
  directorToggle: 'Same model, compare director on/off only',
  director: { on: 'Director on', off: 'Director off' },
  model: 'Writing model for side {side}',
  modelMissing: 'not configured',
  statuses: { ready: 'Not generated', generating: 'Generating', completed: 'Done', failed: 'Failed' },
  metrics: { elapsed: 'Time', calls: 'Model calls', chars: 'Output characters', unbilled: 'Not billed' },
  seconds: '{value} s',
  generatingHint: 'Draft, still generating',
  failedDraft: 'Draft before the failure',
  empty: 'None',
  retry: 'Retry',
  viewRecord: 'View this side’s record',
  adopt: 'Adopt this side',
  adopted: 'Adopted',
  adoptedToast: 'Adopted: {count} turn(s) appended to your run.',
  nextRound: 'Change models and compare another round',
  restart: 'Restart comparison',
}

export const novelComparisonZh = {
  open: '模型对比',
  title: '模型对比',
  fromTurn: '从第 {count} 回合起',
  playerUnknown: '未知玩家',
  sourceMissing: '源对局已删除',
  back: '返回观测页',
  expires: '将于 {time} 自动清理',
  history: '已发生的剧情',
  narrator: '旁白',
  inputMode: '输入方式',
  input: '玩家输入',
  inputHint: '最多 {max} 字，与游玩回合一致',
  send: '两边同时生成',
  directorToggle: '同一模型，只比导演开/关',
  director: { on: '导演开', off: '导演关' },
  model: '{side} 边写作模型',
  modelMissing: '未配置',
  statuses: { ready: '待生成', generating: '生成中', completed: '已完成', failed: '失败' },
  metrics: { elapsed: '耗时', calls: '模型调用次数', chars: '输出字数', unbilled: '未计费' },
  seconds: '{value} 秒',
  generatingHint: '生成中的草稿',
  failedDraft: '失败前的草稿',
  empty: '暂无',
  retry: '重试',
  viewRecord: '查看这一边的记录',
  adopt: '采纳这一边',
  adopted: '已采纳',
  adoptedToast: '已采纳：{count} 个回合追加到了你的对局。',
  nextRound: '换模型再比一回合',
  restart: '重新开始对比',
}

export const novelComparisonJa = {
  open: 'モデル比較',
  title: 'モデル比較',
  fromTurn: '第 {count} ターンから',
  playerUnknown: '不明なプレイヤー',
  sourceMissing: '元のプレイは削除済み',
  back: 'プレイ詳細に戻る',
  expires: '{time} に自動削除されます',
  history: 'これまでの物語',
  narrator: 'ナレーション',
  inputMode: '入力方式',
  input: 'プレイヤーの入力',
  inputHint: '最大 {max} 文字（通常のターンと同じ）',
  send: '両側で同時に生成',
  directorToggle: '同じモデルで監督のオン/オフだけを比べる',
  director: { on: '監督オン', off: '監督オフ' },
  model: '{side} 側の執筆モデル',
  modelMissing: '未設定',
  statuses: { ready: '未生成', generating: '生成中', completed: '完了', failed: '失敗' },
  metrics: { elapsed: '所要時間', calls: 'モデル呼び出し', chars: '出力文字数', unbilled: '課金なし' },
  seconds: '{value} 秒',
  generatingHint: '生成中の下書き',
  failedDraft: '失敗前の下書き',
  empty: 'なし',
  retry: '再試行',
  viewRecord: 'この側の記録を見る',
  adopt: 'この側を採用',
  adopted: '採用済み',
  adoptedToast: '採用しました：{count} ターンをあなたのプレイに追加しました。',
  nextRound: 'モデルを変えてもう 1 ターン比べる',
  restart: '比較をやり直す',
}

export const novelComparisonEs = {
  open: 'Comparar modelos',
  title: 'Comparación de modelos',
  fromTurn: 'Desde el turno {count}',
  playerUnknown: 'Jugador desconocido',
  sourceMissing: 'Partida de origen eliminada',
  back: 'Volver a la partida',
  expires: 'Se eliminará automáticamente el {time}',
  history: 'La historia hasta ahora',
  narrator: 'Narrador',
  inputMode: 'Tipo de entrada',
  input: 'Entrada del jugador',
  inputHint: 'Hasta {max} caracteres, igual que un turno de juego',
  send: 'Generar en ambos',
  directorToggle: 'Mismo modelo, comparar solo director sí/no',
  director: { on: 'Director activado', off: 'Director desactivado' },
  model: 'Modelo de escritura del lado {side}',
  modelMissing: 'sin configurar',
  statuses: { ready: 'Sin generar', generating: 'Generando', completed: 'Listo', failed: 'Error' },
  metrics: { elapsed: 'Tiempo', calls: 'Llamadas al modelo', chars: 'Caracteres generados', unbilled: 'Sin cobro' },
  seconds: '{value} s',
  generatingHint: 'Borrador en curso',
  failedDraft: 'Borrador antes del error',
  empty: 'Nada',
  retry: 'Reintentar',
  viewRecord: 'Ver el registro de este lado',
  adopt: 'Adoptar este lado',
  adopted: 'Adoptado',
  adoptedToast: 'Adoptado: se añadieron {count} turno(s) a tu partida.',
  nextRound: 'Cambiar modelos y comparar otra ronda',
  restart: 'Reiniciar la comparación',
}

export const novelComparisonPt = {
  open: 'Comparar modelos',
  title: 'Comparação de modelos',
  fromTurn: 'A partir do turno {count}',
  playerUnknown: 'Jogador desconhecido',
  sourceMissing: 'Partida de origem excluída',
  back: 'Voltar à partida',
  expires: 'Removida automaticamente em {time}',
  history: 'A história até aqui',
  narrator: 'Narrador',
  inputMode: 'Tipo de entrada',
  input: 'Entrada do jogador',
  inputHint: 'Até {max} caracteres, igual a um turno de jogo',
  send: 'Gerar nos dois',
  directorToggle: 'Mesmo modelo, comparar só diretor ligado/desligado',
  director: { on: 'Diretor ligado', off: 'Diretor desligado' },
  model: 'Modelo de escrita do lado {side}',
  modelMissing: 'não configurado',
  statuses: { ready: 'Não gerado', generating: 'Gerando', completed: 'Concluído', failed: 'Falhou' },
  metrics: { elapsed: 'Tempo', calls: 'Chamadas ao modelo', chars: 'Caracteres gerados', unbilled: 'Sem cobrança' },
  seconds: '{value} s',
  generatingHint: 'Rascunho em geração',
  failedDraft: 'Rascunho antes da falha',
  empty: 'Nada',
  retry: 'Tentar de novo',
  viewRecord: 'Ver o registro deste lado',
  adopt: 'Adotar este lado',
  adopted: 'Adotado',
  adoptedToast: 'Adotado: {count} turno(s) adicionados à sua partida.',
  nextRound: 'Trocar modelos e comparar outra rodada',
  restart: 'Recomeçar a comparação',
}
